import React from 'react';
import { Box, Stack, TextField, Typography } from '@mui/material';

/**
 * Step 4 (conditional) — SeaDrop public-phase config.
 *
 * Only rendered when the chosen contract is `erc721a` + drop strategy
 * is `seadrop`. Allowlist phases are configured post-deploy through
 * a separate flow — out of scope for the create wizard.
 */
export default function StepSeaDrop({ form, setSeaDrop, setPublicStage }) {
  return (
    <Stack spacing='12px'>
      <Box>
        <Typography variant='body1' fontWeight='700' mb='6px'>SeaDrop — Public phase</Typography>
        <Typography variant='body2' color='text.secondary'>
          The default phase anyone can mint during. You can wire allowlist phases after deploy.
        </Typography>
      </Box>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing='8px'>
        <TextField
          size='small'
          label='Price (wei)'
          value={form.seadrop?.public_stage?.price_wei || ''}
          onChange={(e) => setPublicStage('price_wei', e.target.value)}
          placeholder='e.g. 50000000000000000 (= 0.05 ETH)'
          fullWidth
        />
        <TextField
          size='small' type='number'
          label='Max per wallet'
          value={form.seadrop?.public_stage?.max_per_wallet || 0}
          onChange={(e) => setPublicStage('max_per_wallet', Number(e.target.value))}
          sx={{ maxWidth: 150 }}
        />
        <TextField
          size='small' type='number'
          label='Max in phase'
          value={form.seadrop?.public_stage?.max_total || 0}
          onChange={(e) => setPublicStage('max_total', Number(e.target.value))}
          sx={{ maxWidth: 150 }}
        />
      </Stack>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing='8px'>
        <TextField
          size='small' type='datetime-local'
          label='Starts'
          value={form.seadrop?.public_stage?.start_time || ''}
          onChange={(e) => setPublicStage('start_time', e.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          size='small' type='datetime-local'
          label='Ends'
          value={form.seadrop?.public_stage?.end_time || ''}
          onChange={(e) => setPublicStage('end_time', e.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </Stack>
      <TextField
        size='small'
        label='Creator payout address'
        value={form.seadrop?.creator_payout_address || ''}
        onChange={(e) => setSeaDrop('creator_payout_address', e.target.value)}
        placeholder='0x…'
        fullWidth
      />
    </Stack>
  );
}
